import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CarouselArrowLeftIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CarouselArrowLeftIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 10 20">
      <path d="M9 20a1 1 0 01-.78-.35l-7.94-9a1 1 0 010-1.3l7.94-9A1 1 0 019.64.24a1 1 0 01.11 1.41L2.39 10l7.36 8.35a1 1 0 01-.11 1.41A1 1 0 019 20z" />
    </Icon>
  )
}
export default CarouselArrowLeftIcon
